import { useCallback, useMemo } from "react";

import { secureJsonParse } from "_helpers/utils/jsonParser";
import { useFeatureFlags } from "hooks/useFeatureFlags";

interface BetaEdifyModuleConfig {
  packageId: string;
  feedbackFormUrl?: string | null;
}

interface BetaEdifyModuleInterface {
  isBetaEdifyModule: (packageId: string) => boolean;
  getBetaEdifyModuleFeedbackFormUrl: (packageId: string) => string | null;
}

// Defines some util functions to check whether an edify module is in beta based on ConfigCat variable
export const useBetaEdifyModule = (): BetaEdifyModuleInterface => {
  const { betaEdifyModules } = useFeatureFlags();

  const betaEdifyModuleConfig = useMemo(
    () => secureJsonParse<BetaEdifyModuleConfig[]>(betaEdifyModules as string) || [],
    [betaEdifyModules],
  );

  const getBetaEdifyModuleConfig = useCallback(
    (packageId: string): BetaEdifyModuleConfig | null =>
      betaEdifyModuleConfig.find((moduleConfig) => moduleConfig.packageId === packageId) || null,
    [betaEdifyModuleConfig],
  );

  const isBetaEdifyModule = (packageId: string) => !!getBetaEdifyModuleConfig(packageId);

  const getBetaEdifyModuleFeedbackFormUrl = (packageId: string): string | null => {
    const moduleConfig = getBetaEdifyModuleConfig(packageId);
    return moduleConfig?.feedbackFormUrl || null;
  };

  return {
    isBetaEdifyModule,
    getBetaEdifyModuleFeedbackFormUrl,
  };
};
